
import uiLanguageOptions from '~/mixins/ui-language-options'

export default {
  mixins: [uiLanguageOptions],
  props: {
    title: {
      type: String,
      default: null
    },
    back: {
      type: Function,
      default: null
    },
    showLogout: {
      type: Boolean,
      default: false
    },
    contentTitle: {
      type: String,
      default: null
    },
    contentMessage: {
      type: String,
      default: null
    },
    simpleGoBack: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      alert: null,
    }
  },
  computed: {
    client () {
      return this.$store.state.auth.client
    },
    isLoading () {
      return this.$store.state.loadingCount > 0
    },
    hasHeader () {
      return this.title || this.$slots.header
    },
    language: {
      get () {
        return this.$store.state.language
      },
      set (lang) {
        this.$store.dispatch('setLanguage', lang)
      }
    },
  },
  watch: {
    async language () {
      if (!this.client) {
        return
      }
      try {
        await this.$axios.$put('/me', {
          data: {
            id: this.client.id,
            type: this.client.type,
            attributes: {
              language: this.language
            }
          }
        })
      } catch (e) {
        this.$log.error(e)
      }
    }
  },
  methods: {
    setAlert (message, variant = 'red') {
      this.alert = { message, variant }
    },
    clearAlert () {
      this.alert = null
    }
  }
}
